module.exports = __webpack_public_path__ + "Lato-Bold.cd5a66f4f219abfb4bbc.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Bold.ttf
// module id = ../../../../../src/assets/fonts/Lato-Bold.ttf
// module chunks = styles